import { Injectable } from "@angular/core";
import { ThermalApi } from "../thermal-api";

@Injectable()
export class PersonsApi {

    private model: string = 'person';

    constructor(
        private thermalApi: ThermalApi,
    ) {

    }

    findByPage(pass: string, personId: any, length: any, index: any) {
        const method: string = 'GET';
        const func: string = 'findByPage';
        const params: any = {
            pass: pass,
            personId: personId,
            length: length,
            index: index,
        };
        return this.thermalApi.request(method, this.model, func, params);
    }

    createBatchPerson(pass: string, persons: any) {
        const method: string = 'POST';
        const model: string = 'api/v2/person';
        const func: string = 'create';
        const params = new FormData();
        params.append('pass', pass);
        params.append('persons', JSON.stringify(persons));
        return this.thermalApi.request(method, model, func, params);
    }

    delete(pass: string, id: any) {
        const method: string = 'POST';
        const func: string = 'delete';
        const params = new FormData();
        params.append('pass', pass);
        params.append('id', id);
        return this.thermalApi.request(method, this.model, func, params);
    }

}


// WEBPACK FOOTER //
// ./src/shared/thermal/services/persons.api.ts